var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-page-layout w-100 pt-4 pb-4 overflow-auto"},[_c('b-container',{attrs:{"fluid":"xl"}},[_c('div',{staticClass:"base-page-layout_head h3 d-flex justify-between"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("head")],2),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }